import { render, staticRenderFns } from "./CalendarCard.vue?vue&type=template&id=e5fcf308&scoped=true"
import script from "./CalendarCard.vue?vue&type=script&lang=js"
export * from "./CalendarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fcf308",
  null
  
)

export default component.exports